import styled from 'styled-components';
import { Link } from '../../../../../../components/Link/Link';
import { Shade } from '../../../../../../constants/styles';
export const Container = styled.div `
  display: flex;
  justify-content: space-between;
  margin-left: auto;
  margin-right: auto;
  max-width: 1270px;
  padding: 40px 20px;
  width: 100%;
`;
export const Column = styled.div `
  display: flex;
  flex-direction: column;
`;
export const BannersContainer = styled.div `
  background: url('https://displate.com/img/search/pattern.png') 50% no-repeat;
  display: flex;
  flex-wrap: wrap;
  height: 325px;
  width: 500px;
`;
export const StyledImageLink = styled(Link) `
  background-color: ${({ theme }) => theme.colorsV2.ui.background.primary};
  box-shadow: ${Shade.x500};
  height: 155px;
  margin: 0 0 15px 15px;
  max-width: 245px;
  padding: 5px;
  text-decoration: none;
  width: 45%;
  line-height: 1;

  &:hover {
    text-decoration: underline;
  }
`;
export const ImageTitle = styled.span `
  font-size: ${({ theme }) => theme.fontSizes.sizeSm3};
  display: block;
  font-weight: 300;
  padding: 4px 8px;
`;
//# sourceMappingURL=BrowsePostersPanel.styled.js.map